(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["FW-workout-badges"] && !Shopify.designMode) return;
  try {
    
(() => {
 if (customElements.get('fw-workout-carousel-v4')) return;
 customElements.define('fw-workout-carousel-v4', class extends HTMLElement {
  connectedCallback() {
   this.abort?.abort();this.abort=new AbortController();
   const signal=this.abort.signal;
   this.motion=matchMedia('(prefers-reduced-motion: reduce)');
   this.mobile=matchMedia('(max-width: 749px)');this.inView=true;
   this.states=[...this.querySelectorAll('[data-row]')].map(row=>({row,track:row.querySelector('[data-track]'),dots:row.querySelector('[data-dots]'),originals:[...row.querySelector('[data-track]').children],points:[],hover:false,paused:false,manualUntil:0,cloneSets:0}));
   this.refresh=()=>this.states.forEach(state=>this.measure(state));
   this.motion.addEventListener('change',this.refresh,{signal});this.mobile.addEventListener('change',this.refresh,{signal});window.addEventListener('resize',this.refresh,{signal});
   this.states.forEach(state=>{
    state.row.addEventListener('mouseenter',()=>{state.hover=true},{signal});state.row.addEventListener('mouseleave',()=>{state.hover=false},{signal});
    state.track.addEventListener('scroll',()=>this.mark(state),{passive:true,signal});
    state.track.addEventListener('pointerdown',()=>{state.manualUntil=Date.now()+(Number(this.dataset.interval)||5000)},{passive:true,signal});
    state.row.addEventListener('click',event=>{
     const button=event.target.closest('button');if(!button)return;
     if(button.hasAttribute('data-next'))this.advance(state,1);
     if(button.hasAttribute('data-prev'))this.advance(state,-1);
     if(button.hasAttribute('data-point'))this.go(state,Number(button.dataset.point));
     if(button.hasAttribute('data-toggle')){
      state.paused=!state.paused;button.textContent=state.paused?'Play':'Pause';button.setAttribute('aria-label',state.paused?'Play workout autoplay':'Pause workout autoplay');button.setAttribute('aria-pressed',String(state.paused));
     }
     state.manualUntil=Date.now()+(Number(this.dataset.interval)||5000);
    },{signal});
    state.track.addEventListener('keydown',event=>{
     if(event.target!==state.track || !this.enabled())return;
     if(event.key==='ArrowRight' || event.key==='ArrowLeft'){
      event.preventDefault();state.manualUntil=Date.now()+(Number(this.dataset.interval)||5000);this.advance(state,event.key==='ArrowRight'?1:-1);
     }
    },{signal});
    state.row.addEventListener('shopify:block:select',event=>{
     const card=event.target.closest('.fwwo-card');if(!card || !this.enabled())return;
     state.paused=true;state.track.scrollTo({left:card.offsetLeft-state.track.firstElementChild.offsetLeft,behavior:'auto'});
     const pause=state.row.querySelector('[data-toggle]');if(pause){pause.textContent='Play';pause.setAttribute('aria-pressed','true')}
    },{signal});
   });
   if('ResizeObserver'in window){this.resizeObserver=new ResizeObserver(this.refresh);this.states.forEach(state=>this.resizeObserver.observe(state.track))}
   if('IntersectionObserver'in window){this.viewObserver=new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting});this.viewObserver.observe(this)}
   this.refresh();
   if(this.dataset.autoplay==='true'){
    this.timer=setInterval(()=>{
     if(this.dataset.scrollMode==='continuous' || !this.canRun())return;
     this.states.forEach(state=>{if(this.canRunRow(state) && state.points.length>1)this.advance(state,state.row.dataset.direction==='right'?-1:1)});
    },Math.max(2000,Number(this.dataset.interval)||5000));
    this.lastTime=null;
    const tick=time=>{
     const elapsed=this.lastTime===null?0:Math.min(50,time-this.lastTime);this.lastTime=time;
     if(this.dataset.scrollMode==='continuous' && this.canRun())this.states.forEach(state=>{
      if(!state.period)return;
      if(!this.canRunRow(state)){state.position=state.track.scrollLeft;return}
      const sign=state.row.dataset.direction==='right'?-1:1;
      const speed=Math.max(1,Number(state.row.dataset.speed)||20);
      let position=(state.position??state.track.scrollLeft)+sign*speed*elapsed/1000;
      const base=state.period;
      position=base+((position-base)%base+base)%base;
      state.position=position;state.track.scrollLeft=position;
     });
     if(!this.canRun())this.states.forEach(state=>{state.position=state.track.scrollLeft});
     this.frame=requestAnimationFrame(tick);
    };
    this.frame=requestAnimationFrame(tick);
   }
  }
  enabled(){
   if(this.mobile.matches && this.dataset.mobilePresentation==='comfortable')return true;
   if(this.mobile.matches && this.dataset.scrollMode==='continuous' && this.dataset.scrollMobile==='true')return true;
   return !(this.mobile.matches && this.dataset.mobileLayout.startsWith('grid'));
  }
  canRun(){return !this.motion.matches && !document.hidden && this.inView && this.enabled() && !(this.dataset.editor==='true' && this.dataset.autoplayEditor!=='true')}
  canRunRow(state){return !state.paused && !state.row.contains(document.activeElement) && !(this.dataset.pauseHover==='true' && state.hover) && Date.now()>=state.manualUntil}
  cloneCard(card){
   const copy=card.cloneNode(true);copy.setAttribute('data-marquee-clone','');copy.setAttribute('aria-hidden','true');
   [copy,...copy.querySelectorAll('*')].forEach(node=>{
    node.removeAttribute('id');[...node.attributes].forEach(attribute=>{if(attribute.name.startsWith('data-shopify-'))node.removeAttribute(attribute.name)});
   });
   copy.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(node=>node.setAttribute('tabindex','-1'));
   return copy;
  }
  removeClones(state){state.track.querySelectorAll('[data-marquee-clone]').forEach(node=>node.remove());state.cloneSets=0;state.period=0;state.position=null}
  measure(state){
   const wantsLoop=this.dataset.scrollMode==='continuous' && this.dataset.autoplay==='true' && this.enabled() && !this.motion.matches && state.originals.length>0;
   const width=state.originals[0]?.getBoundingClientRect().width || 0;
   const gap=parseFloat(getComputedStyle(state.track).columnGap)||0;
   const period=(width+gap)*state.originals.length;
   const copies=period>0?Math.max(3,Math.ceil(state.track.clientWidth/period)+3):0;
   if(wantsLoop && copies && state.cloneSets!==copies){
    this.removeClones(state);
    const before=document.createDocumentFragment();state.originals.forEach(card=>before.append(this.cloneCard(card)));state.track.prepend(before);
    for(let group=0;group<copies-2;group++){const after=document.createDocumentFragment();state.originals.forEach(card=>after.append(this.cloneCard(card)));state.track.append(after)}
    state.cloneSets=copies;state.period=period;state.track.scrollLeft=period;state.position=period;
   }else if(!wantsLoop && state.cloneSets){this.removeClones(state);state.track.scrollLeft=0}
   if(state.cloneSets)state.period=period;
   const max=Math.max(0,state.track.scrollWidth-state.track.clientWidth),origin=state.track.firstElementChild?.offsetLeft || 0;
   state.points=[];
   state.originals.forEach(card=>{const point=Math.min(max,Math.max(0,card.offsetLeft-origin));if(!state.points.length || point-state.points[state.points.length-1]>2)state.points.push(point)});
   if(!state.points.length)state.points=[0];
   if(!state.cloneSets && max-state.points[state.points.length-1]>2)state.points.push(max);
   state.row.querySelectorAll('[data-carousel-control]').forEach(node=>{node.hidden=!this.enabled() || max<2});
   if(state.dots && state.dotCount!==state.points.length){
    state.dots.replaceChildren();state.points.forEach((point,index)=>{const button=document.createElement('button');button.type='button';button.className='fwwo-dot';button.dataset.point=String(index);button.setAttribute('aria-label',`Show workout position ${index+1}`);button.setAttribute('aria-controls',state.track.id);state.dots.append(button)});state.dotCount=state.points.length;
   }
   state.current=-1;this.mark(state);
  }
  mark(state){
   let closest=0;const left=state.track.scrollLeft;
   state.points.forEach((point,index)=>{if(Math.abs(point-left)<Math.abs(state.points[closest]-left))closest=index});
   if(state.current===closest)return;state.current=closest;
   state.dots?.querySelectorAll('button').forEach((button,index)=>button.setAttribute('aria-current',String(index===closest)));
  }
  go(state,index){
   if(!this.enabled() || !state.points.length)return;
   const normalized=(index+state.points.length)%state.points.length;state.position=state.points[normalized];state.track.scrollTo({left:state.position,behavior:this.motion.matches?'auto':'smooth'});
  }
  advance(state,direction){
   if(!this.enabled() || state.points.length<2)return;this.mark(state);
   if(this.dataset.advance==='page'){
    const target=state.track.scrollLeft+direction*state.track.clientWidth;
    if(direction>0 && state.current===state.points.length-1)return this.go(state,0);
    if(direction<0 && state.current===0)return this.go(state,state.points.length-1);
    let nearest=0;state.points.forEach((point,index)=>{if(Math.abs(point-target)<Math.abs(state.points[nearest]-target))nearest=index});this.go(state,nearest);
   }else this.go(state,state.current+direction);
  }
  disconnectedCallback(){
   this.abort?.abort();clearInterval(this.timer);cancelAnimationFrame(this.frame);this.resizeObserver?.disconnect();this.viewObserver?.disconnect();this.states?.forEach(state=>this.removeClones(state));
  }
 });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coach-showcase"] && !Shopify.designMode) return;
  try {
    
(() => {
 if (customElements.get('fw-coach-showcase')) return;
 customElements.define('fw-coach-showcase', class extends HTMLElement {
  connectedCallback() {
   this.abort?.abort();this.abort=new AbortController();
   const signal=this.abort.signal;
   this.track=this.querySelector('[data-track]');
   this.dots=this.querySelector('[data-dots]');
   this.controls=this.querySelector('[data-controls]');
   this.motion=matchMedia('(prefers-reduced-motion: reduce)');
   this.points=[];this.paused=false;this.hover=false;this.inView=true;this.manualUntil=0;
   this.measure=()=>{
    this.syncTheme();
    const max=Math.max(0,this.track.scrollWidth-this.track.clientWidth);
    const cards=[...this.track.children],origin=cards[0]?.offsetLeft || 0;
    this.points=[0];
    cards.forEach(card=>{const point=Math.min(max,Math.max(0,card.offsetLeft-origin));if(point-this.points[this.points.length-1]>2)this.points.push(point)});
    if(max-this.points[this.points.length-1]>2)this.points.push(max);
    if(this.controls)this.controls.hidden=max<2;
    if(this.dots && this.dotCount!==this.points.length){
     this.dots.replaceChildren();
     this.points.forEach((point,index)=>{
      const button=document.createElement('button');button.type='button';button.className='fwcc-dot';button.dataset.point=String(index);
      button.setAttribute('aria-label',`Show coach position ${index+1}`);button.setAttribute('aria-controls',this.track.id);this.dots.append(button);
     });
     this.dotCount=this.points.length;
    }
    this.mark();
   };
   this.addEventListener('click',event=>{
    const button=event.target.closest('button');if(!button)return;
    if(button.hasAttribute('data-next'))this.go(this.current+1);
    if(button.hasAttribute('data-prev'))this.go(this.current-1);
    if(button.hasAttribute('data-point'))this.go(Number(button.dataset.point));
    if(button.hasAttribute('data-pause')){
     this.paused=!this.paused;button.textContent=this.paused?'Play':'Pause';button.setAttribute('aria-label',this.paused?'Play coach autoplay':'Pause coach autoplay');button.setAttribute('aria-pressed',String(this.paused));
    }
    this.manualUntil=Date.now()+Number(this.dataset.interval);
   },{signal});
   this.addEventListener('mouseenter',()=>{this.hover=true},{signal});
   this.addEventListener('mouseleave',()=>{this.hover=false},{signal});
   this.track.addEventListener('scroll',()=>this.mark(),{passive:true,signal});
   this.track.addEventListener('keydown',event=>{
    if(event.target!==this.track)return;
    if(['ArrowRight','ArrowLeft','Home','End'].includes(event.key)){
     event.preventDefault();this.go(event.key==='Home'?0:event.key==='End'?this.points.length-1:this.current+(event.key==='ArrowRight'?1:-1));this.manualUntil=Date.now()+Number(this.dataset.interval);
    }
   },{signal});
   this.track.addEventListener('pointerdown',event=>{
    this.manualUntil=Date.now()+Number(this.dataset.interval);
    if(event.pointerType==='mouse' && event.button===0)this.drag={x:event.clientX,left:this.track.scrollLeft,id:event.pointerId,moved:false};
   },{signal});
   this.track.addEventListener('pointermove',event=>{
    if(!this.drag || event.pointerId!==this.drag.id)return;
    const distance=event.clientX-this.drag.x;
    if(Math.abs(distance)>8){
     this.drag.moved=true;this.track.classList.add('fwcc-dragging');
     if(!this.track.hasPointerCapture(event.pointerId))this.track.setPointerCapture(event.pointerId);
     event.preventDefault();this.track.scrollLeft=this.drag.left-distance;
    }
   },{signal});
   const endDrag=()=>{
    if(!this.drag)return;
    if(this.drag.moved){this.suppressClickUntil=Date.now()+350;this.mark();this.go(this.current)}
    this.track.classList.remove('fwcc-dragging');this.drag=null;
   };
   this.track.addEventListener('pointerup',endDrag,{signal});
   this.track.addEventListener('pointercancel',endDrag,{signal});
   window.addEventListener('pointerup',endDrag,{signal});
   this.track.addEventListener('dragstart',event=>event.preventDefault(),{signal});
   this.track.addEventListener('click',event=>{if(Date.now()<(this.suppressClickUntil||0)){event.preventDefault();event.stopPropagation()}},{capture:true,signal});
   this.track.addEventListener('shopify:block:select',event=>{
    const card=event.target.closest('.fwcc-card');if(card)this.track.scrollTo({left:card.offsetLeft-this.track.firstElementChild.offsetLeft,behavior:'auto'});
   },{signal});
   window.addEventListener('resize',this.measure,{signal});
   this.addEventListener('load',this.measure,{capture:true,signal});
   if('ResizeObserver'in window){this.resizeObserver=new ResizeObserver(this.measure);this.resizeObserver.observe(this.track)}
   if('IntersectionObserver'in window){this.viewObserver=new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting});this.viewObserver.observe(this)}
   this.measure();
   if(this.dataset.autoplay==='true')this.timer=setInterval(()=>{
    if(this.paused || this.hover || this.drag || this.motion.matches || document.hidden || !this.inView || this.contains(document.activeElement) || Date.now()<this.manualUntil || this.points.length<2)return;
    this.go(this.current+1);
   },Math.max(3000,Number(this.dataset.interval)||5000));
  }
  syncTheme(){
   if(this.dataset.customColors==='true')return;
   let node=this;
   while(node){
    const color=getComputedStyle(node).backgroundColor;
    if(color && color!=='transparent' && !/^rgba\([^)]*,\s*0\s*\)$/.test(color)){
     this.style.setProperty('--coach-surface',color);return;
    }
    node=node.parentElement;
   }
  }
  mark(){
   let closest=0;
   this.points.forEach((point,index)=>{if(Math.abs(point-this.track.scrollLeft)<Math.abs(this.points[closest]-this.track.scrollLeft))closest=index});
   this.current=closest;
   this.dots?.querySelectorAll('button').forEach((button,index)=>button.setAttribute('aria-current',String(index===closest)));
  }
  go(index){
   if(!this.points.length)return;
   const normalized=(index+this.points.length)%this.points.length;
   this.track.scrollTo({left:this.points[normalized],behavior:this.motion.matches?'auto':'smooth'});
  }
  disconnectedCallback(){
   this.abort?.abort();clearInterval(this.timer);this.resizeObserver?.disconnect();this.viewObserver?.disconnect();
  }
 });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fw-client-testimonials"] && !Shopify.designMode) return;
  try {
    

(() => {
 if (customElements.get('fw-client-testimonials')) return;
 customElements.define('fw-client-testimonials', class extends HTMLElement {
  connectedCallback() {
   this.abort?.abort();this.abort=new AbortController();
   const signal=this.abort.signal;
   this.track=this.querySelector('[data-track]');
   this.dots=this.querySelector('[data-dots]');
   this.controls=this.querySelector('[data-controls]');
   this.motion=matchMedia('(prefers-reduced-motion: reduce)');
   this.points=[];this.paused=false;this.hover=false;this.inView=true;this.manualUntil=0;
   this.measure=()=>{
    this.syncTheme();
    const max=Math.max(0,this.track.scrollWidth-this.track.clientWidth);
    const cards=[...this.track.children],origin=cards[0]?.offsetLeft || 0;
    this.points=[0];
    cards.forEach(card=>{const point=Math.min(max,Math.max(0,card.offsetLeft-origin));if(point-this.points[this.points.length-1]>2)this.points.push(point)});
    if(max-this.points[this.points.length-1]>2)this.points.push(max);
    if(this.controls)this.controls.hidden=max<2;
    if(this.dots && this.dotCount!==this.points.length){
     this.dots.replaceChildren();
     this.points.forEach((point,index)=>{
      const button=document.createElement('button');button.type='button';button.className='fwt-dot';button.dataset.point=String(index);
      button.setAttribute('aria-label',`Show testimonial position ${index+1}`);button.setAttribute('aria-controls',this.track.id);this.dots.append(button);
     });
     this.dotCount=this.points.length;
    }
    this.mark();
   };
   this.addEventListener('click',event=>{
    const button=event.target.closest('button');if(!button)return;
    if(button.hasAttribute('data-next'))this.go(this.current+1);
    if(button.hasAttribute('data-prev'))this.go(this.current-1);
    if(button.hasAttribute('data-point'))this.go(Number(button.dataset.point));
    if(button.hasAttribute('data-pause')){
     this.paused=!this.paused;button.textContent=this.paused?'Play':'Pause';button.setAttribute('aria-label',this.paused?'Play testimonial autoplay':'Pause testimonial autoplay');button.setAttribute('aria-pressed',String(this.paused));
    }
    this.manualUntil=Date.now()+Number(this.dataset.interval);
   },{signal});
   this.addEventListener('mouseenter',()=>{this.hover=true},{signal});
   this.addEventListener('mouseleave',()=>{this.hover=false},{signal});
   this.track.addEventListener('scroll',()=>this.mark(),{passive:true,signal});
   this.track.addEventListener('keydown',event=>{
    if(event.target!==this.track)return;
    if(['ArrowRight','ArrowLeft','Home','End'].includes(event.key)){
     event.preventDefault();this.go(event.key==='Home'?0:event.key==='End'?this.points.length-1:this.current+(event.key==='ArrowRight'?1:-1));this.manualUntil=Date.now()+Number(this.dataset.interval);
    }
   },{signal});
   this.track.addEventListener('pointerdown',event=>{
    this.manualUntil=Date.now()+Number(this.dataset.interval);
    if(event.pointerType==='mouse' && event.button===0)this.drag={x:event.clientX,left:this.track.scrollLeft,id:event.pointerId,moved:false};
   },{signal});
   this.track.addEventListener('pointermove',event=>{
    if(!this.drag || event.pointerId!==this.drag.id)return;
    const distance=event.clientX-this.drag.x;
    if(Math.abs(distance)>8){
     this.drag.moved=true;this.track.classList.add('fwt-dragging');
     if(!this.track.hasPointerCapture(event.pointerId))this.track.setPointerCapture(event.pointerId);
     event.preventDefault();this.track.scrollLeft=this.drag.left-distance;
    }
   },{signal});
   const endDrag=()=>{
    if(!this.drag)return;
    if(this.drag.moved){this.suppressClickUntil=Date.now()+350;this.mark();this.go(this.current)}
    this.track.classList.remove('fwt-dragging');this.drag=null;
   };
   this.track.addEventListener('pointerup',endDrag,{signal});
   this.track.addEventListener('pointercancel',endDrag,{signal});
   window.addEventListener('pointerup',endDrag,{signal});
   this.track.addEventListener('dragstart',event=>event.preventDefault(),{signal});
   this.track.addEventListener('click',event=>{if(Date.now()<(this.suppressClickUntil||0)){event.preventDefault();event.stopPropagation()}},{capture:true,signal});
   this.track.addEventListener('shopify:block:select',event=>{
    const card=event.target.closest('.fwt-card');if(card)this.track.scrollTo({left:card.offsetLeft-this.track.firstElementChild.offsetLeft,behavior:'auto'});
   },{signal});
   window.addEventListener('resize',this.measure,{signal});
   this.addEventListener('load',this.measure,{capture:true,signal});
   if('ResizeObserver'in window){this.resizeObserver=new ResizeObserver(this.measure);this.resizeObserver.observe(this.track)}
   if('IntersectionObserver'in window){this.viewObserver=new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting});this.viewObserver.observe(this)}
   this.measure();
   if(this.dataset.autoplay==='true')this.timer=setInterval(()=>{
    if(this.paused || this.hover || this.drag || this.motion.matches || document.hidden || !this.inView || this.contains(document.activeElement) || Date.now()<this.manualUntil || this.points.length<2)return;
    this.go(this.current+1);
   },Math.max(3000,Number(this.dataset.interval)||5000));
  }
  syncTheme(){
   if(this.dataset.customColors==='true')return;
   let node=this;
   while(node){
    const color=getComputedStyle(node).backgroundColor;
    if(color && color!=='transparent' && !/^rgba\([^)]*,\s*0\s*\)$/.test(color)){
     this.style.setProperty('--testimonial-surface',color);return;
    }
    node=node.parentElement;
   }
  }
  mark(){
   let closest=0;
   this.points.forEach((point,index)=>{if(Math.abs(point-this.track.scrollLeft)<Math.abs(this.points[closest]-this.track.scrollLeft))closest=index});
   this.current=closest;
   this.dots?.querySelectorAll('button').forEach((button,index)=>button.setAttribute('aria-current',String(index===closest)));
  }
  go(index){
   if(!this.points.length)return;
   const normalized=(index+this.points.length)%this.points.length;
   this.track.scrollTo({left:this.points[normalized],behavior:this.motion.matches?'auto':'smooth'});
  }
  disconnectedCallback(){
   this.abort?.abort();clearInterval(this.timer);this.resizeObserver?.disconnect();this.viewObserver?.disconnect();
  }
 });
})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fw-lifestyle-join"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('fw-lifestyle-join-v3')) return;
  customElements.define('fw-lifestyle-join-v3', class extends HTMLElement {
    connectedCallback() {
      this.cleanup();
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.onPreference = () => this.start();
      this.motionQuery.addEventListener('change', this.onPreference);
      this.mobileQuery.addEventListener('change', this.onPreference);
      this.onEditorSelect = () => {
        // A selected section or card must remain visible in the editor.
        this.querySelectorAll('.fwl-pending').forEach(el => {
          el.classList.remove('fwl-pending');
          if (this.observer) this.observer.unobserve(el);
        });
      };
      this.addEventListener('shopify:block:select', this.onEditorSelect);
      this.addEventListener('shopify:section:select', this.onEditorSelect);
      this.start();
    }
    start() {
      this.stop();
      if (this.motionQuery.matches || (this.dataset.mobile !== 'true' && this.mobileQuery.matches)) return;
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.remove('fwl-pending');
              if (this.dataset.repeat !== 'true') this.observer.unobserve(entry.target);
            } else if (this.dataset.repeat === 'true') entry.target.classList.add('fwl-pending');
          });
        }, { threshold: 0, rootMargin: '0px 0px -24px 0px' });
        const targets = this.querySelectorAll('[data-reveal]:not([data-reveal="none"])');
        targets.forEach(el => el.classList.add('fwl-pending'));
        this.classList.add('fwl-ready');
        // Commit the starting styles before intersection callbacks reveal content.
        void this.offsetWidth;
        targets.forEach(el => this.observer.observe(el));
      }
      if (this.dataset.parallax === 'true') {
        this.onScroll = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            const viewHeight = window.innerHeight;
            const amount = Number(this.dataset.parallaxAmount) || 16;
            this.querySelectorAll('.fwl-media:not(.fwl-fit--contain)').forEach(el => {
              const rect = el.getBoundingClientRect();
              if (rect.bottom < 0 || rect.top > viewHeight) return;
              const progress = Math.max(-1, Math.min(1, (viewHeight / 2 - rect.top - rect.height / 2) / ((viewHeight + rect.height) / 2)));
              // Clamp to image overscan so no empty edges appear on small cards.
              const shift = progress * Math.min(amount, rect.height * .06);
              el.style.setProperty('--fwl-image-shift', `${shift}px`);
            });
          });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.onScroll();
      }
    }
    stop() {
      if (this.observer) { this.observer.disconnect(); this.observer = null; }
      if (this.onScroll) {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        this.onScroll = null;
      }
      if (this.frame) { cancelAnimationFrame(this.frame); this.frame = null; }
      this.classList.remove('fwl-ready');
      this.querySelectorAll('.fwl-pending').forEach(el => el.classList.remove('fwl-pending'));
      this.querySelectorAll('.fwl-media').forEach(el => el.style.removeProperty('--fwl-image-shift'));
    }
    cleanup() {
      this.stop();
      if (this.onEditorSelect) {
        this.removeEventListener('shopify:block:select', this.onEditorSelect);
        this.removeEventListener('shopify:section:select', this.onEditorSelect);
      }
      if (this.onPreference) {
        this.motionQuery.removeEventListener('change', this.onPreference);
        this.mobileQuery.removeEventListener('change', this.onPreference);
      }
    }
    disconnectedCallback() { this.cleanup(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fw-workout-carousel"] && !Shopify.designMode) return;
  try {
    
(() => {
 if (customElements.get('fw-workout-carousel-v3')) return;
 customElements.define('fw-workout-carousel-v3', class extends HTMLElement {
  connectedCallback() {
   this.abort?.abort();this.abort=new AbortController();
   const signal=this.abort.signal;
   this.motion=matchMedia('(prefers-reduced-motion: reduce)');
   this.mobile=matchMedia('(max-width: 749px)');this.inView=true;
   this.states=[...this.querySelectorAll('[data-row]')].map(row=>({row,track:row.querySelector('[data-track]'),dots:row.querySelector('[data-dots]'),originals:[...row.querySelector('[data-track]').children],points:[],hover:false,paused:false,manualUntil:0,cloneSets:0}));
   this.refresh=()=>this.states.forEach(state=>this.measure(state));
   this.motion.addEventListener('change',this.refresh,{signal});this.mobile.addEventListener('change',this.refresh,{signal});window.addEventListener('resize',this.refresh,{signal});
   this.states.forEach(state=>{
    state.row.addEventListener('mouseenter',()=>{state.hover=true},{signal});state.row.addEventListener('mouseleave',()=>{state.hover=false},{signal});
    state.track.addEventListener('scroll',()=>this.mark(state),{passive:true,signal});
    state.track.addEventListener('pointerdown',()=>{state.manualUntil=Date.now()+(Number(this.dataset.interval)||5000)},{passive:true,signal});
    state.row.addEventListener('click',event=>{
     const button=event.target.closest('button');if(!button)return;
     if(button.hasAttribute('data-next'))this.advance(state,1);
     if(button.hasAttribute('data-prev'))this.advance(state,-1);
     if(button.hasAttribute('data-point'))this.go(state,Number(button.dataset.point));
     if(button.hasAttribute('data-toggle')){
      state.paused=!state.paused;button.textContent=state.paused?'Play':'Pause';button.setAttribute('aria-label',state.paused?'Play workout autoplay':'Pause workout autoplay');button.setAttribute('aria-pressed',String(state.paused));
     }
     state.manualUntil=Date.now()+(Number(this.dataset.interval)||5000);
    },{signal});
    state.track.addEventListener('keydown',event=>{
     if(event.target!==state.track || !this.enabled())return;
     if(event.key==='ArrowRight' || event.key==='ArrowLeft'){
      event.preventDefault();state.manualUntil=Date.now()+(Number(this.dataset.interval)||5000);this.advance(state,event.key==='ArrowRight'?1:-1);
     }
    },{signal});
    state.row.addEventListener('shopify:block:select',event=>{
     const card=event.target.closest('.fwwo-card');if(!card || !this.enabled())return;
     state.paused=true;state.track.scrollTo({left:card.offsetLeft-state.track.firstElementChild.offsetLeft,behavior:'auto'});
     const pause=state.row.querySelector('[data-toggle]');if(pause){pause.textContent='Play';pause.setAttribute('aria-pressed','true')}
    },{signal});
   });
   if('ResizeObserver'in window){this.resizeObserver=new ResizeObserver(this.refresh);this.states.forEach(state=>this.resizeObserver.observe(state.track))}
   if('IntersectionObserver'in window){this.viewObserver=new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting});this.viewObserver.observe(this)}
   this.refresh();
   if(this.dataset.autoplay==='true'){
    this.timer=setInterval(()=>{
     if(this.dataset.scrollMode==='continuous' || !this.canRun())return;
     this.states.forEach(state=>{if(this.canRunRow(state) && state.points.length>1)this.advance(state,state.row.dataset.direction==='right'?-1:1)});
    },Math.max(2000,Number(this.dataset.interval)||5000));
    this.lastTime=null;
    const tick=time=>{
     const elapsed=this.lastTime===null?0:Math.min(50,time-this.lastTime);this.lastTime=time;
     if(this.dataset.scrollMode==='continuous' && this.canRun())this.states.forEach(state=>{
      if(!state.period)return;
      if(!this.canRunRow(state)){state.position=state.track.scrollLeft;return}
      const sign=state.row.dataset.direction==='right'?-1:1;
      const speed=Math.max(1,Number(state.row.dataset.speed)||20);
      let position=(state.position??state.track.scrollLeft)+sign*speed*elapsed/1000;
      const base=state.period;
      position=base+((position-base)%base+base)%base;
      state.position=position;state.track.scrollLeft=position;
     });
     if(!this.canRun())this.states.forEach(state=>{state.position=state.track.scrollLeft});
     this.frame=requestAnimationFrame(tick);
    };
    this.frame=requestAnimationFrame(tick);
   }
  }
  enabled(){
   if(this.mobile.matches && this.dataset.mobilePresentation==='comfortable')return true;
   if(this.mobile.matches && this.dataset.scrollMode==='continuous' && this.dataset.scrollMobile==='true')return true;
   return !(this.mobile.matches && this.dataset.mobileLayout.startsWith('grid'));
  }
  canRun(){return !this.motion.matches && !document.hidden && this.inView && this.enabled() && !(this.dataset.editor==='true' && this.dataset.autoplayEditor!=='true')}
  canRunRow(state){return !state.paused && !state.row.contains(document.activeElement) && !(this.dataset.pauseHover==='true' && state.hover) && Date.now()>=state.manualUntil}
  cloneCard(card){
   const copy=card.cloneNode(true);copy.setAttribute('data-marquee-clone','');copy.setAttribute('aria-hidden','true');
   [copy,...copy.querySelectorAll('*')].forEach(node=>{
    node.removeAttribute('id');[...node.attributes].forEach(attribute=>{if(attribute.name.startsWith('data-shopify-'))node.removeAttribute(attribute.name)});
   });
   copy.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(node=>node.setAttribute('tabindex','-1'));
   return copy;
  }
  removeClones(state){state.track.querySelectorAll('[data-marquee-clone]').forEach(node=>node.remove());state.cloneSets=0;state.period=0;state.position=null}
  measure(state){
   const wantsLoop=this.dataset.scrollMode==='continuous' && this.dataset.autoplay==='true' && this.enabled() && !this.motion.matches && state.originals.length>0;
   const width=state.originals[0]?.getBoundingClientRect().width || 0;
   const gap=parseFloat(getComputedStyle(state.track).columnGap)||0;
   const period=(width+gap)*state.originals.length;
   const copies=period>0?Math.max(3,Math.ceil(state.track.clientWidth/period)+3):0;
   if(wantsLoop && copies && state.cloneSets!==copies){
    this.removeClones(state);
    const before=document.createDocumentFragment();state.originals.forEach(card=>before.append(this.cloneCard(card)));state.track.prepend(before);
    for(let group=0;group<copies-2;group++){const after=document.createDocumentFragment();state.originals.forEach(card=>after.append(this.cloneCard(card)));state.track.append(after)}
    state.cloneSets=copies;state.period=period;state.track.scrollLeft=period;state.position=period;
   }else if(!wantsLoop && state.cloneSets){this.removeClones(state);state.track.scrollLeft=0}
   if(state.cloneSets)state.period=period;
   const max=Math.max(0,state.track.scrollWidth-state.track.clientWidth),origin=state.track.firstElementChild?.offsetLeft || 0;
   state.points=[];
   state.originals.forEach(card=>{const point=Math.min(max,Math.max(0,card.offsetLeft-origin));if(!state.points.length || point-state.points[state.points.length-1]>2)state.points.push(point)});
   if(!state.points.length)state.points=[0];
   if(!state.cloneSets && max-state.points[state.points.length-1]>2)state.points.push(max);
   state.row.querySelectorAll('[data-carousel-control]').forEach(node=>{node.hidden=!this.enabled() || max<2});
   if(state.dots && state.dotCount!==state.points.length){
    state.dots.replaceChildren();state.points.forEach((point,index)=>{const button=document.createElement('button');button.type='button';button.className='fwwo-dot';button.dataset.point=String(index);button.setAttribute('aria-label',`Show workout position ${index+1}`);button.setAttribute('aria-controls',state.track.id);state.dots.append(button)});state.dotCount=state.points.length;
   }
   state.current=-1;this.mark(state);
  }
  mark(state){
   let closest=0;const left=state.track.scrollLeft;
   state.points.forEach((point,index)=>{if(Math.abs(point-left)<Math.abs(state.points[closest]-left))closest=index});
   if(state.current===closest)return;state.current=closest;
   state.dots?.querySelectorAll('button').forEach((button,index)=>button.setAttribute('aria-current',String(index===closest)));
  }
  go(state,index){
   if(!this.enabled() || !state.points.length)return;
   const normalized=(index+state.points.length)%state.points.length;state.position=state.points[normalized];state.track.scrollTo({left:state.position,behavior:this.motion.matches?'auto':'smooth'});
  }
  advance(state,direction){
   if(!this.enabled() || state.points.length<2)return;this.mark(state);
   if(this.dataset.advance==='page'){
    const target=state.track.scrollLeft+direction*state.track.clientWidth;
    if(direction>0 && state.current===state.points.length-1)return this.go(state,0);
    if(direction<0 && state.current===0)return this.go(state,state.points.length-1);
    let nearest=0;state.points.forEach((point,index)=>{if(Math.abs(point-target)<Math.abs(state.points[nearest]-target))nearest=index});this.go(state,nearest);
   }else this.go(state,state.current+direction);
  }
  disconnectedCallback(){
   this.abort?.abort();clearInterval(this.timer);cancelAnimationFrame(this.frame);this.resizeObserver?.disconnect();this.viewObserver?.disconnect();this.states?.forEach(state=>this.removeClones(state));
  }
 });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fw-youtube-content"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('fw-youtube-content-v2')) return;
  customElements.define('fw-youtube-content-v2', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.querySelectorAll('[data-video-play]').forEach(button => {
        button.addEventListener('click', () => {
          const frame = button.closest('.fwy-video');
          const template = frame?.querySelector('[data-video-template]');
          if (!template || frame.querySelector('iframe')) return;
          const iframe = template.content.firstElementChild.cloneNode(true);
          button.replaceWith(iframe);
          iframe.focus();
        }, { signal: this.abort.signal });
      });
      if (this.dataset.animation === 'fade' && 'IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.observer?.disconnect();
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.classList.add('fwy-visible');
            this.observer.disconnect();
          }
        }, { threshold: 0.05 });
        this.classList.add('fwy-reveal-ready');
        this.observer.observe(this);
      }
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class FWHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (this.getAttribute('data-sticky-type') === 'none') return;

      this.header = this.closest('.shopify-section');
      if (!this.header) return;

      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');

      this.currentScrollTop = 0;
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }

  customElements.define('fw-header', FWHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navigation-links"] && !Shopify.designMode) return;
  try {
    
  class NavigationLinks extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      const activeLink = this.querySelector('[aria-current="page"]');
      if (!activeLink) return;

      // Check if the active link is visible in the viewport
      const container = this;
      const containerRect = container.getBoundingClientRect();
      const linkRect = activeLink.getBoundingClientRect();

      // Check if link is outside the visible area
      const isLinkVisible = linkRect.left >= containerRect.left && linkRect.right <= containerRect.right;

      if (!isLinkVisible) {
        // Scroll the active link into view
        activeLink.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center',
        });
      }
    }
  }

  customElements.define('navigation-links', NavigationLinks);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-bar"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('fw-proteinplus-bar')) return;
  customElements.define('fw-proteinplus-bar', class extends HTMLElement {
    connectedCallback() {
      if (this.bar) return;
      this.bar = this.querySelector('.fwp-bar');
      if (!this.bar) return;
      this.editor = this.dataset.editor === 'true';
      this.key = `fw-proteinplus:${this.dataset.campaign}:${this.dataset.section}`;
      this.abort = new AbortController();
      this.spacer = document.createElement('div');
      this.spacer.setAttribute('aria-hidden', 'true');
      this.spacer.style.cssText = 'display:block;width:100%;height:0;pointer-events:none;flex-shrink:0;';
      const style = getComputedStyle(this);
      this.bar.style.setProperty('--fwp-font', style.fontFamily);
      this.bar.style.setProperty('--fwp-font-style', style.fontStyle);
      this.bar.style.setProperty('--fwp-color', style.color);
      let ancestor = this;
      while (ancestor) {
        const background = getComputedStyle(ancestor).backgroundColor;
        if (background && background !== 'transparent' && !/^rgba\([^)]*,\s*0(?:\.0+)?\)$/.test(background)) {
          this.bar.style.setProperty('--fwp-surface', background); break;
        }
        ancestor = ancestor.parentElement;
      }
      // Mount outside theme containers so transforms cannot trap the fixed bar.
      document.body.append(this.spacer, this.bar);
      this.bar.querySelector('[data-close]').addEventListener('click', () => this.dismiss(), { signal: this.abort.signal });
      const end = Date.parse(this.dataset.expiry || '');
      this.end = this.dataset.expire === 'true' && Number.isFinite(end) ? end : null;
      const expired = this.end !== null && Date.now() >= this.end;
      if (this.dataset.enabled !== 'true' || (!this.editor && (expired || this.isDismissed()))) return;
      this.bar.hidden = false;
      this.resize = new ResizeObserver(() => this.syncSpace());
      this.resize.observe(this.bar);
      this.syncSpace();
      if (!this.editor && this.end !== null) {
        this.timer = setInterval(() => { if (Date.now() >= this.end) this.hide(); }, 1000);
      }
    }
    isDismissed() {
      try { return this.dataset.dismiss === 'session' && sessionStorage.getItem(this.key) === '1'; } catch { return false; }
    }
    dismiss() {
      if (!this.editor && this.dataset.dismiss === 'session') {
        try { sessionStorage.setItem(this.key, '1'); } catch {}
      }
      this.hide();
    }
    syncSpace() {
      if (this.spacer) this.spacer.style.height = this.dataset.reserve === 'true' && !this.bar.hidden ? `${Math.ceil(this.bar.getBoundingClientRect().height)}px` : '0px';
    }
    hide() { this.bar.hidden = true; this.syncSpace(); clearInterval(this.timer); }
    disconnectedCallback() {
      this.abort?.abort(); this.resize?.disconnect(); clearInterval(this.timer);
      this.bar?.remove(); this.spacer?.remove(); this.bar = null;
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
